// Patch: required multi-selects don't open dropdown in v0.14.0.
// The open() method checks $control_input.is(":invalid"), which is always
// true for empty required multi-selects, preventing the dropdown from opening.
// Fix landed in v0.15.0 (commit 0be6036) but v0.15.0 introduced a replaceWith
// bug that silently drops form values, so we stay on v0.14.0 and backport here.
// https://github.com/selectize/selectize.js/issues/1909

const Selectize = require('@selectize/selectize');

Selectize.prototype.open = function () {
  var self = this;
  if (self.isLocked || self.isOpen || (self.settings.mode === 'multi' && self.isFull())) return;
  self.focus();
  self.isOpen = true;
  self.refreshState();
  self.$dropdown.css({ visibility: 'hidden', display: 'block' });
  self.setupDropdownHeight();
  self.positionDropdown();
  self.$dropdown.css({ visibility: 'visible' });
  self.trigger('dropdown_open', self.$dropdown);
};
